module.exports = __webpack_public_path__ + "img/Villa_Borna_29.93a1555c.jpg";